import React, { ReactElement, useEffect, useRef, useState } from 'react';
import classes from './ModalConfigureReranker.module.scss';
import { ModalDefault } from 'new/routes/ModalDefault';
import useReranker from 'new/elements/flows/ModalConfigureReranker/useReranker';
import { Form } from 'new/elements/Form';
// import { StepsSection } from 'new/elements/Form/StepsSection';
import { SelectConnectionStep } from 'new/elements/flows/ModalConfigureReranker/steps/SelectConnectionStep';
import { EnterCredentialStep } from 'new/elements/flows/ModalConfigureReranker/steps/EnterCredentialStep';
import useEntities from 'new/state/entities/repository/useEntities';
import { useVendors } from 'new/state/vendors/repository/useVendors';

type ModalConfigureLLMProps = {
  parentNexset?: any;
  editingNexset?: any;
  ButtonComponent?: ReactElement;
};

const config = {
  disableClickOut: true,
};

const PREVENT_NAVIGATION_BEFORE_FORM_SUBMISSION = true;

export const ModalConfigureReranker = (props: ModalConfigureLLMProps) => {
  const [open, setOpen] = useState(false);
  const { ButtonComponent, editingNexset, parentNexset } = props;

  const { data, connectionType, updateFormData, resetFormData, startForm, endForm } = useReranker();

  const { data: credentials } = useEntities('credentials');
  const { vendors } = useVendors();

  const start = useRef(true);

  if (start.current && open) {
    startForm();
    updateFormData({
      connectionType: 'SINK',
      flowType: 'reranker',
    });
    start.current = false;
  }

  function resetFields() {
    resetFormData([
      'credentialId',
      'selectedCredentialInfo',
      'selectedConnection',
      'selectedBucket',
      'selectedTable',
      'table',
      'source',
      'sink',
      'nexset',
      'isNewTable',
      'sourceConfig',
      'sinkConfig',
    ]);
  }

  useEffect(() => {
    resetFields();
    return () => {
      resetFields();
      if (connectionType === 'SINK') {
        endForm();
      }
    };
  }, []);

  useEffect(() => {
    if (editingNexset) {
      const selectedCredential = credentials[editingNexset?.data_credentials_id];
      const selectedCredentialId = selectedCredential?.id;
      const selectedConnection = selectedCredential?.vendor_id
        ? vendors[selectedCredential.vendor_id]?.name
        : selectedCredential?.connector?.type;

      updateFormData({
        data: {
          ...data,
          ...editingNexset?.custom_config?.props,
        },
        selectedConnection,
        selectedCredential,
        selectedCredentialId,
        credentialId: selectedCredentialId,
      });
    }
  }, [credentials, vendors, editingNexset]);

  const onFormDismiss = () => {
    setOpen(false);
    endForm();
    return PREVENT_NAVIGATION_BEFORE_FORM_SUBMISSION;
  };

  const onOpen = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
    endForm();
  };

  return (
    <>
      {ButtonComponent ? React.cloneElement(ButtonComponent, { onClick: onOpen }) : null}
      <ModalDefault
        onCancel={onClose}
        config={config}
        rootClassName={classes.modalRootContainer}
        contentClassName={classes.modalContainer}
        renderTitle={({ Title, Container }) => (
          <Container className={classes.titleContainer}>
            <Title>Add Reranker</Title>
          </Container>
        )}
        open={open}
      >
        <Form
          isModal
          containerClassName={classes.formContainer}
          onDismiss={onFormDismiss}
          // HeaderComponent={
          //   <StepsSection
          //     onCancel={onClose}
          //     containerClassName={classes.stepsSection}
          //   />
          // }
          description=""
          startPage={!!editingNexset?.id ? 1 : undefined}
        >
          <SelectConnectionStep />
          <EnterCredentialStep
            editingNexset={editingNexset}
            parentNexset={parentNexset}
            onClose={onClose}
          />
        </Form>
      </ModalDefault>
    </>
  );
};
